<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { tick } from 'svelte';
import InfoTooltip from './InfoTooltip.svelte';

export let availableLLMs = [];
export let llmIsSelected = false;
export let selectedLLM;
export let dropdownIndex = 0;
export let relevantStore;

export { updateDropdownIndex };

let isDropdownOpen = false;
let dropdownButton;

relevantStore.subscribe((update) => {
  updateDropdownIndex();
});

//set dropdownindex to selected LLM if LLM has been selected, otherwise index=0
//we use an index as a the value for the dropdown because the options of the dropdown are beeing updated every 30sec.
async function updateDropdownIndex() {
  await tick();
  if (selectedLLM !== undefined) {
    dropdownIndex = availableLLMs.findIndex((llm) => llm.name === selectedLLM.name);
    if (dropdownIndex === -1) {
      dropdownIndex = 0;
    }
  }
}

function toggleDropdown() {
  isDropdownOpen = !isDropdownOpen;
}

function selectModel(index) {
  dropdownIndex = index;
  llmIsSelected = true;
  selectedLLM = availableLLMs[index];
  isDropdownOpen = false;
}

function handleClickOutside(event) {
  if (dropdownButton && !dropdownButton.contains(event.target)) {
    isDropdownOpen = false;
  }
}

updateDropdownIndex();
</script>

<svelte:window on:click={handleClickOutside} />

<div class="model-selector-container" bind:this={dropdownButton}>
    <button
        class="model-icon-button"
        on:click|stopPropagation={toggleDropdown}
        title="Sprachmodell auswählen"
        aria-label="Sprachmodell auswählen"
        aria-expanded={isDropdownOpen}
    >
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="cpu-icon">
            <path d="M12.4688 7.875H8.53125C8.3572 7.875 8.19028 7.94414 8.06721 8.06721C7.94414 8.19028 7.875 8.3572 7.875 8.53125V12.4688C7.875 12.6428 7.94414 12.8097 8.06721 12.9328C8.19028 13.0559 8.3572 13.125 8.53125 13.125H12.4688C12.6428 13.125 12.8097 13.0559 12.9328 12.9328C13.0559 12.8097 13.125 12.6428 13.125 12.4688V8.53125C13.125 8.3572 13.0559 8.19028 12.9328 8.06721C12.8097 7.94414 12.6428 7.875 12.4688 7.875ZM11.8125 11.8125H9.1875V9.1875H11.8125V11.8125ZM19.0312 11.8125H17.7188V9.1875H19.0312C19.2053 9.1875 19.3722 9.11836 19.4953 8.99529C19.6184 8.87222 19.6875 8.7053 19.6875 8.53125C19.6875 8.3572 19.6184 8.19028 19.4953 8.06721C19.3722 7.94414 19.2053 7.875 19.0312 7.875H17.7188V4.59375C17.7188 4.24565 17.5805 3.91181 17.3343 3.66567C17.0882 3.41953 16.7543 3.28125 16.4062 3.28125H13.125V1.96875C13.125 1.7947 13.0559 1.62778 12.9328 1.50471C12.8097 1.38164 12.6428 1.3125 12.4688 1.3125C12.2947 1.3125 12.1278 1.38164 12.0047 1.50471C11.8816 1.62778 11.8125 1.7947 11.8125 1.96875V3.28125H9.1875V1.96875C9.1875 1.7947 9.11836 1.62778 8.99529 1.50471C8.87222 1.38164 8.7053 1.3125 8.53125 1.3125C8.3572 1.3125 8.19028 1.38164 8.06721 1.50471C7.94414 1.62778 7.875 1.7947 7.875 1.96875V3.28125H4.59375C4.24565 3.28125 3.91181 3.41953 3.66567 3.66567C3.41953 3.91181 3.28125 4.24565 3.28125 4.59375V7.875H1.96875C1.7947 7.875 1.62778 7.94414 1.50471 8.06721C1.38164 8.19028 1.3125 8.3572 1.3125 8.53125C1.3125 8.7053 1.38164 8.87222 1.50471 8.99529C1.62778 9.11836 1.7947 9.1875 1.96875 9.1875H3.28125V11.8125H1.96875C1.7947 11.8125 1.62778 11.8816 1.50471 12.0047C1.38164 12.1278 1.3125 12.2947 1.3125 12.4688C1.3125 12.6428 1.38164 12.8097 1.50471 12.9328C1.62778 13.0559 1.7947 13.125 1.96875 13.125H3.28125V16.4062C3.28125 16.7543 3.41953 17.0882 3.66567 17.3343C3.91181 17.5805 4.24565 17.7188 4.59375 17.7188H7.875V19.0312C7.875 19.2053 7.94414 19.3722 8.06721 19.4953C8.19028 19.6184 8.3572 19.6875 8.53125 19.6875C8.7053 19.6875 8.87222 19.6184 8.99529 19.4953C9.11836 19.3722 9.1875 19.2053 9.1875 19.0312V17.7188H11.8125V19.0312C11.8125 19.2053 11.8816 19.3722 12.0047 19.4953C12.1278 19.6184 12.2947 19.6875 12.4688 19.6875C12.6428 19.6875 12.8097 19.6184 12.9328 19.4953C13.0559 19.3722 13.125 19.2053 13.125 19.0312V17.7188H16.4062C16.7543 17.7188 17.0882 17.5805 17.3343 17.3343C17.5805 17.0882 17.7188 16.7543 17.7188 16.4062V13.125H19.0312C19.2053 13.125 19.3722 13.0559 19.4953 12.9328C19.6184 12.8097 19.6875 12.6428 19.6875 12.4688C19.6875 12.2947 19.6184 12.1278 19.4953 12.0047C19.3722 11.8816 19.2053 11.8125 19.0312 11.8125ZM16.4062 16.4062H4.59375V4.59375H16.4062V12.4581C16.4062 12.4581 16.4062 12.4655 16.4062 12.4688C16.4062 12.472 16.4062 12.4761 16.4062 12.4794V16.4062Z" fill="currentColor"/>
        </svg>
    </button>

    {#if isDropdownOpen}
        <div class="model-dropdown">
            <div class="dropdown-header">
                <span>Sprachmodell auswählen</span>
                <InfoTooltip
                    infoText="Abhängig von der Modellauswahl können unterschiedliche Textantworten generiert werden. Weitere Informationen zu den jeweiligen Modellen und Hosting-Optionen finden Sie in den FAQ."
                />
            </div>
            <div class="dropdown-list">
                {#each availableLLMs as model, i}
                    <button
                        class="dropdown-item"
                        class:selected={i === dropdownIndex}
                        on:click={() => selectModel(i)}
                    >
                        <span class="model-name">{model.label}</span>
                        {#if model.is_remote}
                            <span class="cloud-icon">☁</span>
                        {/if}
                        {#if i === dropdownIndex}
                            <span class="check-icon">✓</span>
                        {/if}
                    </button>
                {/each}
            </div>
        </div>
    {/if}
</div>

<style>
    .model-selector-container {
        position: relative;
        display: inline-block;
    }

    .model-icon-button {
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        border: 1px solid #000;
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.2s ease;
        padding: 0;
    }

    .model-icon-button:hover {
        background-color: #f5f5f5;
        border-color: #333;
    }

    .model-icon-button:active {
        background-color: #e8e8e8;
    }

    .model-icon-button:focus-visible {
        outline: 2px solid #000;
        outline-offset: 2px;
    }

    .cpu-icon {
        width: 21px;
        height: 21px;
        color: #000;
    }

    .model-dropdown {
        position: absolute;
        bottom: calc(100% + 8px);
        left: 0;
        min-width: 280px;
        background-color: white;
        border: 1px solid #d0d0d0;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 1000;
        animation: slideDown 0.2s ease;
    }

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(4px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .dropdown-header {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 16px;
        border-bottom: 1px solid #e5e5e5;
        font-weight: 600;
        font-size: 0.9rem;
        color: #333;
    }

    .dropdown-list {
        max-height: 300px;
        overflow-y: auto;
        padding: 8px;
    }

    .dropdown-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        padding: 10px 12px;
        background-color: transparent;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        transition: background-color 0.15s ease;
        text-align: left;
        font-size: 0.95rem;
        color: #333;
    }

    .dropdown-item:hover {
        background-color: #f5f5f5;
    }

    .dropdown-item.selected {
        background-color: #f0f0f0;
    }

    .model-name {
        flex: 1;
        font-weight: 500;
    }

    .cloud-icon {
        font-size: 1rem;
        color: #666;
    }

    .check-icon {
        font-size: 1.1rem;
        color: #000;
        font-weight: bold;
    }

    .dropdown-list::-webkit-scrollbar {
        width: 6px;
    }

    .dropdown-list::-webkit-scrollbar-track {
        background: transparent;
    }

    .dropdown-list::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 3px;
    }

    .dropdown-list::-webkit-scrollbar-thumb:hover {
        background: #999;
    }
</style>
